module.exports = require('./lib/heap');



//////////////////
// WEBPACK FOOTER
// ./~/heap/index.js
// module id = 75
// module chunks = 0